__turbopack_context__.v({
  "crawlerDivider": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerDivider",
  "crawlerDropdownBox": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerDropdownBox",
  "crawlerDropdownContainer": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerDropdownContainer",
  "crawlerDropdownItem": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerDropdownItem",
  "crawlerDropdownLink": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerDropdownLink",
  "crawlerDropdownList": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerDropdownList",
  "crawlerDropdownTrigger": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerDropdownTrigger",
  "crawlerExpandableHeader": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerExpandableHeader",
  "crawlerExpandableLink": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerExpandableLink",
  "crawlerExpandableList": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerExpandableList",
  "crawlerSecondaryLabel": "CrawlerDropdown-module-scss-module__wGyNBa__crawlerSecondaryLabel",
});
